import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigCartDetailsComponent } from './uig-cart-details.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { UigCartSharedModule } from '../uig-cart-shared/uig-cart-shared.module';
import { UigShopViewGuard } from 'src/app/organization/guards/uig-shop-view.guard';

@NgModule({
  declarations: [UigCartDetailsComponent],
  imports: [
    UigCartSharedModule,
    CommonModule,
    I18nModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CartComponent: {
          component: UigCartDetailsComponent,
          guards: [UigShopViewGuard],
        },
      },
    }),
  ],
  exports: [UigCartDetailsComponent],
})
export class UigCartDetailsModule { }
